/**
 * @generated SignedSource<<a43d9154d93e9101c3c53b809e629d78>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type DocsExportModalAsyncTaskQuery$variables = {
  taskId: any;
};
export type DocsExportModalAsyncTaskQuery$data = {
  readonly viewer: {
    readonly asyncTask: {
      readonly info: any;
      readonly state: string;
      readonly taskId: any;
    } | null;
  };
};
export type DocsExportModalAsyncTaskQuery = {
  response: DocsExportModalAsyncTaskQuery$data;
  variables: DocsExportModalAsyncTaskQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "taskId"
  }
],
v1 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "taskId",
      "variableName": "taskId"
    }
  ],
  "concreteType": "AsyncTask",
  "kind": "LinkedField",
  "name": "asyncTask",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "taskId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "state",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "info",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DocsExportModalAsyncTaskQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DocsExportModalAsyncTaskQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "3e9732e89fc281d8ace5eddb84756b10",
    "id": null,
    "metadata": {},
    "name": "DocsExportModalAsyncTaskQuery",
    "operationKind": "query",
    "text": "query DocsExportModalAsyncTaskQuery(\n  $taskId: JSON!\n) {\n  viewer {\n    asyncTask(taskId: $taskId) {\n      taskId\n      state\n      info\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "53527bc271853d2c126ae0de0f480033";

export default node;
